module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('dealHeader', {
    attrs: {
      "deal": _vm.deal,
      "deal_contact": _vm.deal_contact,
      "stages": _vm.stages,
      "company_users": _vm.company_users,
      "deal_activities": _vm.deal_activities
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "content-side-bar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticClass: "widget-content text-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 deal_page_sidebar_content pointer"
  }, [_c('div', [_c('span', {
    on: {
      "click": function($event) {
        _vm.ShowContact(_vm.deal_contact.contact_token)
      }
    }
  }, [_vm._v(_vm._s(_vm.deal_contact.name))]), _vm._v(" "), _c('a', {
    staticClass: "row-edit",
    on: {
      "click": function($event) {
        _vm.changeContactModal = true
      }
    }
  }, [_c('span', {
    staticClass: "zmdi zmdi-edit pointer"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deal.edit == 'no' || _vm.deal.edit != _vm.deal.deal_organization_name),
      expression: "deal.edit=='no' || deal.edit!=deal.deal_organization_name"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.ShowOrganization(_vm.deal.deal_organization_token)
      }
    }
  }, [_vm._v(" - " + _vm._s(_vm.deal.deal_organization_name))]), _vm._v(" "), (_vm.deal.deal_organization_name == '' || _vm.deal.deal_organization_name == null) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deal.edit == 'no' || _vm.deal.edit != _vm.deal.deal_organization_name),
      expression: "deal.edit=='no' || deal.edit!=deal.deal_organization_name"
    }],
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.ShowOrganization(_vm.deal.deal_organization_token)
      }
    }
  }, [_vm._v(" - 無所屬公司")]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v("交易建立時間：" + _vm._s(_vm.deal.created_at))]), _vm._v(" "), (_vm.deal.deal_status == 'won') ? _c('div', [(_vm.canEditColumn('deal_time', _vm.deal.deal_token)) ? _c('datepicker', {
    staticStyle: {
      "width": "150px",
      "display": "inline-block"
    },
    attrs: {
      "input-class": "form-control",
      "language": "zh",
      "format": 'yyyy/MM/dd'
    },
    on: {
      "selected": function($event) {
        _vm.dateSelected()
      }
    },
    model: {
      value: (_vm.deal.deal_time),
      callback: function($$v) {
        _vm.deal.deal_time = $$v
      },
      expression: "deal.deal_time"
    }
  }) : _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.editColumn('deal_time', _vm.deal.deal_token)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t    \t\t\t交易完成時間：" + _vm._s(_vm.customFormatter(_vm.deal.deal_time)) + " "), _c('i', {
    staticClass: "fa fa-pencil-alt"
  })])], 1) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_c('div', {
    staticClass: "deal_sidebar block-header clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "row-edit",
    on: {
      "click": function($event) {
        _vm.loadingQuotation();
        _vm.CreateQuotation()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "widget-container v-step-6-8",
    attrs: {
      "id": "quotation_box"
    }
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_vm._l((_vm.quotations), function(quotation) {
    return _c('p', {
      staticClass: "single_quotation",
      attrs: {
        "id": quotation.quotation_token
      }
    }, [(quotation.is_draft) ? _c('span', [_vm._v("\n                            草稿 - " + _vm._s(quotation.quotation_title) + "\n                          ")]) : _c('span', [_vm._v("\n                            " + _vm._s(quotation.quotation_title) + "\n                          ")]), _vm._v(" "), (quotation.is_draft) ? _c('button', {
      staticClass: "btn btn-xs btn-warning",
      on: {
        "click": function($event) {
          _vm.ShowQuotation(quotation.quotation_token)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-alt"
    })]) : _vm._e(), _vm._v(" "), (quotation.is_draft) ? _c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          _vm.deleteQuotationModal = true;
          _vm.delete_quotation = quotation
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e(), _vm._v(" "), (!quotation.is_draft) ? _c('a', {
      staticClass: "btn btn-xs btn-success",
      attrs: {
        "href": _vm.axios.defaults.baseURL + '/pdf_generators/quotation.html?quotation_token=' + quotation.quotation_token,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })]) : _vm._e(), _vm._v(" "), (!quotation.is_draft) ? _c('a', {
      staticClass: "btn btn-xs btn-info",
      attrs: {
        "href": _vm.axios.defaults.baseURL + '/pdf_generators/quotation.pdf?quotation_token=' + quotation.quotation_token,
        "target": "_blank"
      }
    }, [_vm._v("PDF")]) : _vm._e(), _vm._v(" "), (!quotation.is_draft) ? _c('button', {
      staticClass: "btn btn-xs btn-warning",
      on: {
        "click": function($event) {
          _vm.copyQuotationWording(quotation);
          _vm.copyQuotation(quotation)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-copy"
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.quotations.length == 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.loadingQuotation();
        _vm.CreateQuotation()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 建立空白報價單")])]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('activitiesResource', {
    staticClass: "v-step-6-7",
    attrs: {
      "activities": _vm.deal_activities,
      "activity_categories": _vm.activity_categories
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 v-step-6-6"
  }, [_c('div', {
    staticClass: "material-table-widget dashboard_top_bar"
  }, [_c('a', {
    staticClass: "btn btn-default v-step-6-2",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.loadingQuotation();
        _vm.CreateQuotation()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 報價單")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default v-step-6-3",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.temp_activity.content_type = 'note';
        _vm.showNoteModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 留言")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default v-step-6-4",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.temp_activity.content_type = 'event';
        _vm.showActivityModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 待辦事項")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default v-step-6-5",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.temp_activity.content_type = 'attachment';
        _vm.showUploadModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 檔案")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(_vm.deal.deal_status == 'open') ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.deal.deal_status = 'won';
        _vm.update_deal_status(1)
      }
    }
  }, [_vm._v("獲得交易")]) : _vm._e(), _vm._v(" "), (_vm.deal.deal_status == 'open') ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.deal.deal_status = 'lost';
        _vm.update_deal_status(2)
      }
    }
  }, [_vm._v("失去交易")]) : _vm._e(), _vm._v(" "), (_vm.deal.deal_status != 'open') ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.deal.deal_status = 'open';
        _vm.update_deal_status(0)
      }
    }
  }, [_vm._v("重啟交易")]) : _vm._e()])]), _vm._v(" "), _c('history', {
    attrs: {
      "activities": _vm.deal_activities,
      "activity_categories": _vm.activity_categories
    }
  })], 1)])], 1)]), _vm._v(" "), (_vm.changeContactModal) ? _c('div', {
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.changeContactModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.changeContactModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-8",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_vm._v("\n                變更聯絡人 - 請輸入已存在的聯絡人名稱\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.changeContactModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow": "initial"
    }
  }, [_c('div', {
    staticClass: "row j-forms"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(2), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "url": _vm.axios.defaults.baseURL + '/settings/auto_complete',
      "anchor": "name",
      "label": "organization_name",
      "param": "keyword",
      "name": "autocomplete",
      "placeholder": "聯絡人*",
      "classes": {
        input: 'form-control  deal_contact_name',
        wrapper: 'input-wrapper'
      },
      "process": _vm.process_contact_JSON,
      "onSelect": _vm.handle_contact_Select,
      "onInput": _vm.set_contact_Value,
      "customHeaders": _vm.auth_token,
      "customParams": {
        type: 'contact'
      }
    },
    model: {
      value: (_vm.deal_contact_name),
      callback: function($$v) {
        _vm.deal_contact_name = $$v
      },
      expression: "deal_contact_name"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms col-md-12"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.updateDealContact(_vm.deal.deal_token)
      }
    }
  }, [_vm._v("\n                  變更\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.changeContactModal = false
      }
    }
  }, [_vm._v("\n                  取消\n                ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.deleteQuotationModal) ? _c('div', {
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.deleteQuotationModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.deleteQuotationModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-4",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(3), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.deleteQuotationModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row j-forms"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("你確定要刪除這個報價單嗎？編號：" + _vm._s(_vm.delete_quotation.latest_date))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms col-md-12"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.deleteQuotationDraft(_vm.delete_quotation)
      }
    }
  }, [_vm._v("\n                  刪除\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.deleteQuotationModal = false
      }
    }
  }, [_vm._v("\n                  取消\n                ")])])])])])])]) : _vm._e(), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  }), _vm._v(" "), (_vm.showNoteModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.showNoteModal = false;
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper ",
    on: {
      "click": function($event) {
        _vm.showNoteModal = false;
      }
    }
  }, [_c('div', {
    staticClass: "modal-container modal-center col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_vm._m(4), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showNoteModal = false;
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body scroll j-forms"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('label', {
    attrs: {
      "for": "textarea"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "autosize",
      rawName: "v-autosize",
      value: (_vm.temp_activity.content),
      expression: "temp_activity.content"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_activity.content),
      expression: "temp_activity.content"
    }],
    staticClass: "bootstrap_textarea",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "3",
      "placeholder": "新增留言內容"
    },
    domProps: {
      "value": (_vm.temp_activity.content)
    },
    on: {
      "keydown": function($event) {
        _vm.content_type = 'note'
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_activity.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-info primary-btn",
    on: {
      "click": _vm.add_activity
    }
  }, [_vm._v("新增")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showActivityModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.showActivityModal = false;
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.showActivityModal = false;
      }
    }
  }, [_c('div', {
    staticClass: "modal-container modal-center col-md-8",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_vm._m(5), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showActivityModal = false;
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms noscroll"
  }, [_c('div', {
    staticClass: "j-forms"
  }, [_c('div', {
    staticClass: "text-left form-group"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "..."
    }
  }, _vm._l((_vm.activity_categories), function(category) {
    return _c('button', {
      staticClass: "btn btn-default",
      class: {
        active: _vm.temp_activity.activity_category_id === category.id
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.temp_activity.activity_category_id = category.id
        }
      }
    }, [_c('i', {
      class: category.icon
    }), _vm._v(" " + _vm._s(category.title))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(6), _vm._v(" "), _c('datepicker', {
    attrs: {
      "input-class": "form-control",
      "language": "zh",
      "format": 'yyyy-MM-dd'
    },
    on: {
      "selected": _vm.startDateMove
    },
    model: {
      value: (_vm.temp_activity.start_date),
      callback: function($$v) {
        _vm.temp_activity.start_date = $$v
      },
      expression: "temp_activity.start_date"
    }
  })], 1)])]), _vm._v(" "), (_vm.temp_activity.allDay == false) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "時間",
      "format": "HH:mm",
      "minute-interval": 5
    },
    model: {
      value: (_vm.temp_activity.start_time),
      callback: function($$v) {
        _vm.temp_activity.start_time = $$v
      },
      expression: "temp_activity.start_time"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._m(7), _vm._v(" "), (_vm.temp_activity.allDay == false) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "時間",
      "format": "HH:mm",
      "minute-interval": 5
    },
    model: {
      value: (_vm.temp_activity.end_time),
      callback: function($$v) {
        _vm.temp_activity.end_time = $$v
      },
      expression: "temp_activity.end_time"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(8), _vm._v(" "), _c('datepicker', {
    attrs: {
      "input-class": "form-control",
      "language": "zh",
      "format": 'yyyy-MM-dd'
    },
    on: {
      "selected": _vm.startDateMove
    },
    model: {
      value: (_vm.temp_activity.end_date),
      callback: function($$v) {
        _vm.temp_activity.end_date = $$v
      },
      expression: "temp_activity.end_date"
    }
  })], 1)])]), _vm._v(" "), (_vm.temp_activity.allDay == true) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.temp_activity.allDay = false
      }
    }
  }, [_vm._v("增加時間")])]) : _vm._e()]), _vm._v(" "), (_vm.temp_activity.time_warning) ? _c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("結束時間必須在開始時間之後")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row grid-divider"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_activity.title),
      expression: "temp_activity.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "待辦事項*",
      "name": "title"
    },
    domProps: {
      "value": (_vm.temp_activity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_activity.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('title')),
      expression: "errors.has('title')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('title')),
      expression: "errors.has('title')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("標題為必填\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "autosize",
      rawName: "v-autosize",
      value: (_vm.temp_activity.content),
      expression: "temp_activity.content"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_activity.content),
      expression: "temp_activity.content"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "placeholder": "事項備註"
    },
    domProps: {
      "value": (_vm.temp_activity.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_activity.content = $event.target.value
      }
    }
  }, [_vm._v(_vm._s(_vm.temp_activity.content))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(10), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_activity.user_id),
      expression: "temp_activity.user_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.temp_activity.user_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("指派*")]), _vm._v(" "), _vm._l((_vm.company_users), function(user) {
    return _c('option', {
      domProps: {
        "value": user.value
      }
    }, [_vm._v(_vm._s(user.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input left-icon-input"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_activity.location),
      expression: "temp_activity.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "地點"
    },
    domProps: {
      "value": (_vm.temp_activity.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_activity.location = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "..."
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: {
      active: _vm.temp_activity.activity_priority === 'low'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.temp_activity.activity_priority = 'low';
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flag",
    staticStyle: {
      "color": "gray"
    }
  }), _vm._v("優先度低")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    class: {
      active: _vm.temp_activity.activity_priority === 'middle'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.temp_activity.activity_priority = 'middle';
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v("優先度中")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    class: {
      active: _vm.temp_activity.activity_priority === 'high'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.temp_activity.activity_priority = 'high';
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v("優先度高")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("\n                  建立\n                ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showUploadModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.showUploadModal = false;
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper ",
    on: {
      "click": function($event) {
        _vm.showUploadModal = false;
      }
    }
  }, [_c('div', {
    staticClass: "modal-container modal-center col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_vm._m(12), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showUploadModal = false;
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms"
  }, [_c('dropzone', {
    attrs: {
      "id": "myVueDropzone",
      "url": _vm.axios.defaults.baseURL + '/activities',
      "headers": _vm.auth_token,
      "maxFileSizeInMB": 20
    },
    on: {
      "vdropzone-success": _vm.file_uploaded
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "deal_token"
    },
    domProps: {
      "value": this.$route.params.deal_token
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "activity[deal_id]"
    },
    domProps: {
      "value": _vm.deal.deal_id
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "activity[user_id]"
    },
    domProps: {
      "value": _vm.user_id
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "activity[content_type]",
      "value": "attachment"
    }
  })])], 1)])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deal_sidebar block-header clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("交易資訊")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("報價單")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h5', [_vm._v("刪除報價單")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "header text-center"
    }
  }, [_c('div', {
    staticClass: "widget-header margin-bottom-0 clearfix"
  }, [_c('h4', [_vm._v("新增留言")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "header text-center"
    }
  }, [_c('div', {
    staticClass: "widget-header margin-bottom-0 clearfix"
  }, [_c('h4', [_vm._v("新增待辦事項")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('span', {
    staticStyle: {
      "line-height": "39px",
      "font-size": "20px"
    }
  }, [_vm._v("～")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "text"
    }
  }, [_c('i', {
    staticClass: "fas fa-map-marker"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "header text-center"
    }
  }, [_c('div', {
    staticClass: "widget-header margin-bottom-0 clearfix"
  }, [_c('h4', [_vm._v("上傳檔案")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-939b3caa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Deals/SalesManagement.vue
// module id = 705
// module chunks = 4